// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fade-enter-active[data-v-12b712be],.fade-leave-active[data-v-12b712be]{-webkit-transition:opacity .3s;transition:opacity .3s}.fade-enter[data-v-12b712be],.fade-leave-to[data-v-12b712be]{opacity:0}", ""]);
// Exports
module.exports = exports;
